export default __webpack_public_path__ + "static/23-ae02f4c7ad3c724fdced8d25e41df3f4.png";